import template from "./bInputCheckbox.html";

export function bInputCheckboxDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bInputCheckboxController,
    controllerAs: 'bInputCheckbox',
    bindToController: true,
    transclude: true,
    scope: {
      data: "=",
    }
  };

  return directive;
}

class bInputCheckboxController {
  constructor() {
    'ngInject';
  }
}